import * as React from "react";
import {observer} from "mobx-react";
import {observable} from "mobx";
import {Button} from "reactstrap";
import {CrudPageStore} from "../../stores/CrudPageStore";
import {FormModal} from "./CrudFormModal";
import {PageContent} from "../Layout";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";

@observer
export class CrudPage extends React.Component {
    modelName: string;
    @observable store: CrudPageStore;
    actionButton: boolean = true;

    constructor(props: any) {
        super(props);

        // modelName is set in child constructor
        setTimeout(() => {
            this.store = new CrudPageStore(this.modelName);
        }, 0);
    }

    render() {
        if (!this.store) {
            return null;
        }

        const {formClass, listClass} = this.store;

        if (!formClass || !listClass) {
            return null;
        }
        const listComponent = React.createElement(listClass, {
            listTableStore: this.store.listTableStore,
            onAdd: this.store.openFormModal,
			onEdit: this.store.openFormModal,
            onDelete: this.store.delete,
            actionComponent: this.actionButton && (
                <HasPermission module={snakeCase(this.modelName)} permission="add">
                    <Button color="primary" onClick={() => this.store.openFormModal()}>
                        <span className="icon-add"/>Add
                    </Button>
                </HasPermission>
            )
        });

        return (
            <>
                <PageContent>
                    {listComponent}
                </PageContent>

                <FormModal store={this.store}/>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/crud/CrudPage.tsx